
import Axios from "axios";
import { Component, Vue } from "vue-property-decorator";
import { RESOLVE_MODULE_PERMISSIONS } from "@/services/auth";
import Avatar from "vue-avatar";
import DomainFooter from "@/views/layout/AppFooter.vue";
import { isSubdomain } from "@/services/common";
import PortalHeader from "@/views/layout/headers/dashboardHeader/DashboardHeader.vue";
import IdleVue from "idle-vue";

@Component({ components: { DomainFooter, IdleVue, Avatar, PortalHeader } })
export default class ClientDashboardComponent extends Vue {
  public navigationRoutes = RESOLVE_MODULE_PERMISSIONS();
  public isSubdomainUrl = false;

  public async onIdle() {
    if (window.location.href.includes(this.$DOMAIN_ADDRESS)) {
      await this.$store.dispatch("allClear");
      Vue.prototype.$client = null;
      Vue.prototype.$adminId = null;
      Vue.prototype.$companyName = null;
      Vue.prototype.$clientPermission = null;
      Vue.prototype.$clientLogo = null;
    } else await this.$store.dispatch("clearSession");
    // this.$socket.client.emit("userDisconnected", {
    //   keyName: "InstantPayment",
    //   userId: this.$userId,
    // });
    this.$router.push("/login");
  }

  public get hasSession() {
    return !this.$lodash.isEmpty(this.$store.state.sessionObject);
  }
  public get isSuperAdmin() {
    return (
      !this.$lodash.isEmpty(this.$store.state.sessionObject) &&
      this.$store.state.sessionObject.user.userType == 0
    );
  }

  public computeRouteState(index: number) {
    return this.navigationRoutes[index].routes.every((r) => {
      let parts = this.$route.path.split("/");
      if (r.to.includes("void")) {
        return true;
      }
      if (r.to.includes(parts[0] + "/" + parts[1] + "/" + parts[2])) {
        return true;
      }
      return false;
    });
  }

  mounted() {
    this.isSubdomainUrl = isSubdomain();
    /**
     * Logic to collapse the menu section
     */
    window.addEventListener("click", () => {
      let sectionElement = document.getElementsByTagName("section")[0];
      if (!!sectionElement && sectionElement.classList.contains("open")) {
        let moduleClassElements: any = document.getElementsByClassName(
          "module"
        );
        for (let i = 0; i < moduleClassElements.length; i++) {
          const element = moduleClassElements[i];
          element.lastChild.classList.remove("show");
        }
      }
    });
  }
}
